import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=45e73195&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=45e73195&prod&scoped=true&lang=css"
import style1 from "./shopList.vue?vue&type=style&index=1&id=45e73195&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e73195",
  null
  
)

export default component.exports